import React, { useEffect, useState } from "react";
import S from "./Staff.styled";
import { IStaff, IWPTitleParts } from "@/src/types";
import { MainInner, MainSection, motionAnimation } from "@/styles/global";
import { Body, DisplayHeadingS, H3 } from "@/styles/typography";
import { Link } from "@/styles/components";
import { gatsbyImageHelper } from "@/src/helpers";
import TitleParts from "@/components/global-components/TitleParts";
import { motion } from "framer-motion";

export interface StaffProps {
  blockId: string;
  titleParts: IWPTitleParts;
  title: string;
  type: "text" | "image";
  staff: IStaff;
  staffData?: IStaff;
}

const Staff: React.FC<StaffProps> = ({
  titleParts,
  title,
  type,
  staff,
  staffData,
  blockId = "",
}) => {
  const [data, setData] = useState<IStaff>([]);

  useEffect(() => {
    setData(staff ?? staffData);
  }, [staff, setData]);

  const renderStaff = data?.map(({ staffInfo }, i) => {
    const { position, image, firstName, lastName, email, linkedin, calendly } =
      staffInfo;
    const imageData = gatsbyImageHelper(image);

    return (
      <S.Card key={i}>
        <S.CardImage $type={type}>
          {type === "text" ? (
            <DisplayHeadingS size={"36px"}>{position}</DisplayHeadingS>
          ) : (
            <>
              {imageData && (
                <S.Image
                  image={imageData}
                  alt={image.altText}
                  objectPosition={"top"}
                />
              )}
            </>
          )}
        </S.CardImage>
        <H3 margin="0 0 8px 0">
          {firstName} {lastName}
        </H3>

        {calendly ? (
          <Link url={calendly} target="_blank">
            <Body size={16} margin="8px 0">
              Book a meeting
            </Body>
          </Link>
        ) : (
          email && (
            <Link url={`mailto:${email}`}>
              <Body size={16} margin="8px 0">
                {email}
              </Body>
            </Link>
          )
        )}
      </S.Card>
    );
  });

  return (
    <S.Section as={motion.section} {...motionAnimation} id={blockId}>
      <MainInner>
        <DisplayHeadingS margin="0 0 24px 0">
          {titleParts ? (
            <TitleParts titleParts={titleParts} backgroundColor="white" />
          ) : (
            title && title
          )}
        </DisplayHeadingS>
        <S.Grid>{renderStaff}</S.Grid>
      </MainInner>
    </S.Section>
  );
};

export default Staff;
